<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Sala de Espera</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="nombre"
                prepend-icon="mdi-account"
                label="Nombre Sala de Espera *"
                maxlength="50"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarSalaEspera"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    nombre: null,
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
  }),

  props: ["visible", "idSalaEspera"],

  computed: {
    show: {
      get() {
        if (this.visible) this.buscarDatosSalaEspera();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    buscarDatosSalaEspera() {
      let self = this;

      axios
        .get("/Profesional/BuscarDatosSalaEspera?", {
          params: {
            idSalaEspera: this.idSalaEspera,
          },
        })
        .then((response) => {
          self.nombre = response.data.nombreSalaEspera;
        })
        .catch((error) => {});
    },
    modificarSalaEspera() {
      this.$swal({
        title: "Modificar Sala de Espera",
        text: "¿Desea modificar el nombre de la sala de espera?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosSalaEspera = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idSalaEspera: this.idSalaEspera,
            nombreSalaEspera: this.nombre,
          };
          let self = this;
          axios
            .post("/Profesional/ModificarSalaEspera", datosSalaEspera)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title:
                    "Ya existe una sala de espera registrada con ese nombre",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();

                document.getElementsByClassName(
                  "v-dialog--active"
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Sala de espera modificada exitosamente",
                  vm: self,
                });
                self.$emit("salaEsperaModificada");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "La Sala de Espera no pudo ser modificada",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
